export const checkTypeEnum = {
  LOADING: 0,
  HAS_STANDARD: 1,
  NOT_STANDARD: 2,
  MANUAL: 3
}
export const tabColum = [
  {
    title: '考核中',
    key: checkTypeEnum.LOADING
  },
  {
    title: '已达标',
    key: checkTypeEnum.HAS_STANDARD
  },
  {
    title: '未达标',
    key: checkTypeEnum.NOT_STANDARD
  },
  {
    title: '手动转正',
    key: checkTypeEnum.MANUAL
  }
]
